import "./DashboardModule.scss";
import "react-datepicker/dist/react-datepicker.css";
import React, { useRef, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import moment from "moment";
import DatePicker, { CalendarContainer } from "react-datepicker";
import Calendar from "../../Images/blue_calendar.svg";
import TP_DateRange from "../../components/DateRangePicker";
import TP_DashDateRange from "../../components/common/DateRangePicker2";
import Button from "../../components/common/Button";
import System from "../../Images/system.svg";
import Training_Logo from "../../Images/training.svg";
import Delete from "../../Images/delete_red_icon.svg";
import ToolTip from "../../components/common/Tooltip";
import Info from "../../Images/yellow_info_icon.svg";
import ToggleButton from "../../components/ToggleButton";
import DashboardTraining from "../../components/DashboardTraining";
import DashboradGraph from "../../components/DashboardGraph";
import { useDispatch, useSelector } from "react-redux";
import { DashboardData, DashboardGraph } from "../../redux/features/dashboard";
import { Training } from "../../redux/features/Training";
import Dropdown from "../../components/common/Dropdown";
import CsvDownloader from "react-csv-downloader";
import { ImageStatus } from "../../redux/features/ImageConfigurator";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
} from "chart.js";
import { Line } from "react-chartjs-2";
import BreadCrumb from "../../components/BreadCrumb";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API } from "../../globals/constants";
import { ConfirmImage } from "../../redux/features/ImageConfigurator";
import Cookies from "universal-cookie";
import Google from "../../Images/google-cloud.svg";
import Aws from "../../Images/aws-cloud.svg";
import MultiLine_Spinner from "../../components/multiline_spinner/Multiline_spinner";

ChartJS.register(LineElement, PointElement, LinearScale, Title);

const DASHBOARD = () => {
  const start_date = moment().subtract(7, "days");
  const end_date = moment();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const datepicker_ref = useRef();
  const [dateRange, setDateRange] = useState([
    start_date.format("DD-MM-YYYY"),
    end_date.format("DD-MM-YYYY"),
  ]);
  //const [startDate, endDate] = dateRange;
  const [imageData, setImageData] = useState([]);
  const [regionSpecific, setRegionSpecific] = useState([]);
  const [isGridAVisible, setIsGridAVisible] = useState(true);
  const [apiResponseData, setApiResponseData] = useState([]);
  const [vmListing, setVmListing] = useState([]);
  const [loadApi, setLoadApi] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );

  let prevStartDate;

  const [month, setMonth] = useState("");
  const [yearData, setYearData] = useState([]);
  const [year, setYear] = useState("");
  const [dashboardData, setDashboardData] = useState([]);
  const [training, setTraining] = useState([]);
  const [graphData, setGraphData] = useState({});
  const [sessionGraphData, setSessionGraphData] = useState({});

  const [vmState, setVmState] = useState("all_vm");
  const [sessionState, setSessionState] = useState("all_ss");

  const [runninggraphData, setRunningGraphData] = useState({});
  const [stoppedgraphData, setStoppedGraphData] = useState({});
  const [completedgraphData, setCompletedGraphData] = useState({});
  const [totalTraining, setTotalTraining] = useState({});
  const [totalStudents, setTotalStudents] = useState({});
  const [totalInstructors, setTotalInstructors] = useState({});
  const [avgSessionLength, setAvgSessionLength] = useState({});
  const [totalHours, setTotalHours] = useState({});

  const [checkedState, setCheckedState] = useState("unchecked");
  const [gridView, setGridView] = useState(false);
  const [plotPoints, setPlotPoints] = useState([]);
  const [interval, setInterval] = useState([]);
  const [monthData, setMonthData] = useState([
    { value: "Jan", id: 1, label: "January" },
    { value: "Feb", id: 2, label: "February" },
    { value: "Mar", id: 3, label: "March" },
    { value: "Apr", id: 4, label: "April" },
    { value: "May", id: 5, label: "May" },
    { value: "Jun", id: 6, label: "June" },
    { value: "Jul", id: 7, label: "July" },
    { value: "Aug", id: 8, label: "August" },
    { value: "Sep", id: 9, label: "September" },
    { value: "Oct", id: 10, label: "October" },
    { value: "Nov", id: 11, label: "November" },
    { value: "Dec", id: 12, label: "December" },
  ]);
  const [faq, setFaq] = useState([
    {
      id: 1,
      question: "What is Cumulo?",
      show: true,
      answer:
        "Cumulo is a live training dashboard that allows Unreal Authorized instructors to schedule and conduct training sessions for trainees.",
    },
    {
      id: 2,
      question: "What does Cumulo provide for trainees?",
      show: false,
      answer:
        "Cumulo provides Virtual Machines (VMs) for trainees with low-end machines for getting trained on Unreal Engine.",
    },
    {
      id: 3,
      question:
        "Can trainees use their own machines to access the Virtual Machines?",
      show: false,
      answer:
        "Trainees can use their own machines to access the Virtual machines and the training. They will need Chrome browser installed and in some cases might have to install Teradici’s PCoIP tool or use Window’s built in remote desktop (RDP) interface.",
    },
    {
      id: 4,
      question: "Is there a cost to use the Virtual Machines?",
      show: false,
      answer:
        "We provide Virtual Machines for free and there is no cost associated with it.",
    },
    // {
    //   id: 5,
    //   question: "Can we modify the feedback forms?",
    //   show: false,
    //   answer:
    //     `Yes, the feedback forms can be modified to suit the instructor's training session. You can modify using this link`,
    // },
  ]);

  const datefilter = async (range) => {
    let startDate = range[0];
    let endDate = range[1];
  };
  const handleToggleClick = () => {
    setIsGridAVisible(!isGridAVisible);
  };
  const handleDateChange = (sDate, eDate) => {
    setStartDate(sDate);
    setEndDate(eDate);
  };

  useEffect(() => {
    if (isGridAVisible === true) {
      if (prevStartDate !== startDate) {
        prevStartDate = startDate;
        getGraph(createVMGraphData, "DASHBOARD_GRAPH");
      }
    } else {
      if (prevStartDate !== startDate) {
        prevStartDate = startDate;
        getGraph(createSessionGraphData, "DASHBOARD_SESSION_GRAPH");
      }
    }
  }, [isGridAVisible, startDate, endDate]);

  const { loginResponse, loading, error } = useSelector((state) => {
    return state.login;
  });
  const cookies = new Cookies();
  const { email_id, token, role_code, name, studio_id, id } =
    cookies.get("loginData");

  console.log(
    "onst loginResponse = cookies.get('loginData');",
    cookies.get("loginData")
  );
  const { dashboardResponse } = useSelector((state) => {
    return state.dashboard;
  });
  const onHandleChange = (id) => {
    console.log(id);
    let data = [...faq];
    let faq_selected = data.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          show: !item.show,
        };
      } else {
        return {
          ...item,
          show: false,
        };
      }
    });

    setFaq([...faq_selected]);
  };

  const handleVm = (value) => {
    setVmState(value);
  };
  const handleSs = (value) => {
    setSessionState(value);
  };
  const handleMonth = (selected) => {
    setMonth(selected);
  };
  const handleYear = (selected) => {
    setYear(selected);
  };
  const data = {
    labels: ["Red", "Blue", "Yellow"],
    datasets: [
      {
        data: [12, 15, 5],
      },
    ],
  };
  const getDashboard = async () => {
    console.log("dateRange[1]", startDate, endDate);
    let params =
      role_code === "SUPER_ADMIN"
        ? {
            from_date: moment(start_date).format("YYYY-MM-DD"),
            end_date: moment(end_date).format("YYYY-MM-DD"),
          }
        : {
            from_date: moment(start_date).format("YYYY-MM-DD"),
            end_date: moment(end_date).format("YYYY-MM-DD"),
            studio_id: studio_id,
          };

    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].DASHBOARD +
        API.END_POINTS.ADMIN_DASHBOARD
      }`,
      params,
      {},
      {}
    );
    if (response.status === 200) {
      setDashboardData(response.data.data);
      setRegionSpecific(response.data.data.total_trainings);
      setTraining(response.data.data.todaysTraining);
    }
  };
  const createVMGraphData = (response) => {
    if (response.status === 200) {
      setGraphData(response.data.data);
      let line1 =
        Object.keys(response.data.data.line1?.totalRunningVM).length > 0
          ? response.data.data.line1?.totalRunningVM
          : {};
      let line2 =
        Object.keys(response.data.data.line2?.totalStoppedVM).length > 0
          ? response.data.data.line2?.totalStoppedVM
          : {};
      let line3 =
        Object.keys(response.data.data.line3?.completedVM).length > 0
          ? response.data.data.line3?.completedVM
          : {};
      const plotPoints = response.data.data.points;
      const interval = response.data.data.interval;
      setInterval(interval);
      setPlotPoints(plotPoints);
      setRunningGraphData(line1);
      setStoppedGraphData(line2);
      setCompletedGraphData(line3);
    }
  };
  const createSessionGraphData = (response) => {
    if (response.status === 200) {
      setSessionGraphData(response.data.data);
      let line1 =
        Object.keys(response.data.data.total_trainings).length > 0
          ? response.data.data.total_trainings
          : {};
      let line2 =
        Object.keys(response.data.data.total_students).length > 0
          ? response.data.data.total_students
          : {};
      let line3 =
        Object.keys(response.data.data.total_instructors).length > 0
          ? response.data.data.total_instructors
          : {};
      let line4 =
        Object.keys(response.data.data.average_session_length).length > 0
          ? response.data.data.average_session_length
          : {};
      let line5 =
        Object.keys(response.data.data.total_hours).length > 0
          ? response.data.data.total_hours
          : {};

      const plotPoints = response.data.data.points;
      console.log("PP", plotPoints);
      const interval = response.data.data.interval;
      setInterval(interval);
      setPlotPoints(plotPoints);
      setTotalTraining(line1);
      setTotalStudents(line2);
      setTotalInstructors(line3);
      setAvgSessionLength(line4);
      setTotalHours(line5);
    }
  };
  const getGraph = async (createGraphDataFn, path) => {
    let from_date = moment(startDate).format("YYYY-MM-DD");
    let end_date = moment(endDate).format("YYYY-MM-DD");
    let params =
      role_code === "SUPER_ADMIN"
        ? { from_date: from_date, end_date: end_date }
        : {
            from_date,
            studio_id: studio_id,
            end_date,
          };

    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].DASHBOARD +
        API.END_POINTS[path]
      }`,
      params,
      {},
      {}
    );
    console.log("Inside graphData", response);
    createGraphDataFn(response);
  };
  let from_date = moment(startDate).format("YYYY-MM-DD");
  console.log("fd", from_date);
  const getImageStatus = async () => {
    setIsloading(true);
    const response = await api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.IMAGE_STATUS
      }`,
      {
        createdBy: role_code === "STUDIO_ADMIN" ? studio_id : id,
      },
      {},
      {}
    );
    if (response.status === 200) {
      setImageData(response?.data?.data ? response?.data?.data : []);
      setIsloading(false);
    }
  };
  const handleVerify = (arn, name, action, cloud_type) => {
    navigate("/admin/imageconfigurator", {
      state: {
        arn_id: arn,
        step: 2,
        ami_name: name,
        action: action,
        cloud_type: cloud_type,
      },
    });
  };
  const handleEdit = (arn, name, action) => {
    navigate("/admin/imageconfigurator", {
      state: {
        arn_id: arn,
        step: action === "retry" ? 1 : 0,
        action: action,
      },
    });
  };
  const handleExport = () => {
    document.getElementById("export_csv").click();
  };
  const handleConfirm = (arn, name) => {
    navigate("/admin/imageconfigurator", {
      state: {
        arn_id: arn,
        step: 2,
        ami_name: name,
        cloud_type: "GCP",
      },
    });
  };

  const handleOk = async (arn, ami_name, cloud_type, edit) => {
    setIsloading(true);
    let bodyParam = {
      is_accept: false,
      arn: arn,
      ami_name: ami_name,
      created_by: id,
      isFail: true,
      studio_id: studio_id,
      cloud_type: cloud_type,
      is_edit: edit,
    };
    const response = await api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.CONFIRM_IMAGE
      }`,
      {},
      {},
      bodyParam
    );
    if (response.status === 200) {
      setIsloading(false);
      getImageStatus();
      let filterData = imageData.filter((item) =>
        console.log("filterdata check ----", item.arn === arn)
      );

      setImageData([...filterData]);
    }
  };
  useEffect(() => {
    let yearDropdown = [];
    let currentYear = new Date().getFullYear();
    let earliestYear = 2021;
    for (let i = earliestYear; i <= currentYear; i++) {
      let temp = [...yearDropdown];
      temp.push({
        id: i,
        label: i,
        value: i,
      });
      yearDropdown = [...temp];
    }
    setYearData([...yearDropdown]);
    let year_temp = yearDropdown.filter(
      (item) => item.value === new Date().getFullYear()
    );
    setYear(year_temp[0]);
  }, []);
  useEffect(() => {
    let start_date = moment(dateRange[0]).format("YYYY-MM-DD");
    let end_date = moment(dateRange[1]).format("YYYY-MM-DD");
    let params = {
      from_date: start_date,
      end_date: end_date,
    };

    let temp = monthData.filter(
      (item) => item.value === moment().format("MMM")
    );
    setMonth(temp[0]);

    getDashboard();

    getImageStatus();
  }, []);

  useEffect(() => {
    getDashboard();
    getImageStatus();
    if (role_code === "STUDIO_ADMIN") {
    } else {
    }
  }, [startDate]);
  useEffect(() => {
    getDashboard();
    getImageStatus();
    if (role_code === "STUDIO_ADMIN") {
    } else {
    }
  }, [endDate]);
  useEffect(() => {}, [imageData]);
  return (
    <>
      <Grid container spacing={2} className="dashboard">
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <span className="larger_f_bold">Dashboard</span>
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={3} xl={3}></Grid>
        <Grid item xs={5} sm={3} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3} spacing={0}>
          <Grid container className="training_details">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container className="Schedule_header">
                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                  <Stack className="system_Img">
                    <img src={System}></img>
                  </Stack>
                </Grid>
                <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                  <Stack className="Schedule_training">
                    <Typography className="dashboard_heading training_heading">
                      This Week Scheduled Trainings
                    </Typography>
                    <Typography className="dashboard_heading">
                      {dashboardData?.totalSession}
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="Scheduled"
            >
              {regionSpecific.map((item, i) => {
                return (
                  <Stack className="bg_Color">
                    <Stack
                      className={
                        i % 2 !== 0 ? "training_Region" : "padding_class"
                      }
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5} xl={1.5}>
                          {item?.region_training?.cloud_type === "GCP" ? (
                            <img src={Google} />
                          ) : (
                            <img src={Aws} />
                          )}
                        </Grid>
                        <Grid item xs={7.5} sm={7.5} md={7.5} lg={7.5} xl={7.5}>
                          <Typography className="Region">
                            {/* {item.region_training} */}
                            {item?.region_training?.region_name}
                          </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                          <Typography className="Region">
                            {item?.total_count}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Stack>
                  </Stack>
                );
              })}
            </Grid>
          </Grid>
          <Grid conatiner spacing={0} className="faq">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="faq_heading">FAQs</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="faq_sets"
            >
              {faq.map((item) => {
                return (
                  <Grid
                    container
                    spacing={0}
                    className="faq_content"
                    onClick={() => onHandleChange(item.id)}
                  >
                    <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                      <Typography className="faq_content">
                        {item.question}
                      </Typography>
                      {item.show === true ? (
                        <Grid xs={10} sm={10} md={10} lg={10} xl={10}>
                          <Typography className="faq_content">
                            {item.answer}
                          </Typography>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                      <Typography className="set_symbol">
                        {item.show === true ? "-" : "+"}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
          {imageData.length > 0 ? (
            <Grid container spacing={1} className="approval_content">
              {imageData?.map((item, i) => {
                return (
                  <Grid container className="approval_data">
                    <Grid container>
                      <Grid xs={12} sm={12} md={9} lg={9} xl={9}>
                        {item.status === "AVAILABLE" ? (
                          <Typography className="approval">
                            Hey, Your {item?.ami_name} is pending for approval
                          </Typography>
                        ) : item.status === "FAILED" ? (
                          <Typography className="approval">
                            Hey, Your {item?.ami_name} is failed...
                          </Typography>
                        ) : (
                          <Typography className="approval">
                            Hey, Your {item?.ami_name} is in building state...
                          </Typography>
                        )}
                      </Grid>

                      {item.status === "AVAILABLE" ? (
                        item.cloud_type === "aws" ? (
                          <>
                            <Grid xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                              <Button
                                role="default"
                                value="Edit"
                                onClick={() =>
                                  handleEdit(item?.arn, item?.name, "edit")
                                }
                                className="approval_edit"
                              />
                            </Grid>
                            <Grid xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                              <Button
                                role="primary"
                                value="Verify"
                                onClick={() =>
                                  handleVerify(
                                    item?.arn,
                                    item?.ami_name,
                                    "verify",
                                    item?.cloud_type
                                  )
                                }
                                className="approval_verify"
                              />
                            </Grid>
                          </>
                        ) : (
                          <Button
                            role="default"
                            value="Confirm"
                            onClick={() =>
                              handleConfirm(item?.arn, item?.ami_name)
                            }
                            className="approval_edit"
                          />
                        )
                      ) : item.status === "FAILED" ? (
                        item.cloud_type === "aws" ? (
                          <>
                            <Grid xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                              <Button
                                role="default"
                                value="Ok"
                                onClick={() =>
                                  handleOk(
                                    item?.arn,
                                    item?.ami_name,
                                    item?.cloud_type,
                                    item?.edit
                                  )
                                }
                                className="approval_edit"
                              />
                            </Grid>
                            <Grid xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                              <Button
                                role="primary"
                                value="Retry"
                                onClick={() =>
                                  handleEdit(item?.arn, item?.name, "retry")
                                }
                                className="approval_verify"
                              />
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                              <Button
                                role="default"
                                value="Ok"
                                onClick={() =>
                                  handleOk(
                                    item?.arn,
                                    item?.ami_name,
                                    item?.cloud_type
                                  )
                                }
                                className="approval_edit"
                              />
                            </Grid>
                          </>
                        )
                      ) : (
                        <Grid xs={6} sm={6} md={1.5} lg={1.5} xl={1.5}>
                          <Typography className="approval approval_status approval_building">
                            Building...
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            ""
          )}
          <Grid
            container
            spacing={0}
            className={
              imageData.length > 0 ? "graph_select" : "set_graph_height"
            }
          >
            <Grid container justifyContent={"space-between"}>
              <ToggleButton
                value={isGridAVisible}
                onClick={() => {
                  handleToggleClick();
                }}
              />
              <div className="cal">
                <TP_DashDateRange
                  handleDateChange={handleDateChange}
                  startDate={startDate}
                  endDate={endDate}
                  isClear={true}
                  monthsShown={"2"}
                />
              </div>
            </Grid>

            {isGridAVisible ? (
              <>
                <Grid container spacing={0} className="graph_Option">
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    xl={3}
                    className={
                      vmState === "all_vm"
                        ? " Vm all_Vm "
                        : "align_Text set_Border"
                    }
                    onClick={() => handleVm("all_vm")}
                  >
                    <Typography default className="text_Font">
                      Total VM
                    </Typography>
                    <Typography className="number_Font">
                      {graphData.totalVM}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    xl={3}
                    className={
                      vmState === "running_vm"
                        ? " Vm running_vm "
                        : "align_Text set_Border"
                    }
                    onClick={() => handleVm("running_vm")}
                  >
                    <Typography className="text_Font">
                      Total Running VM
                    </Typography>
                    <Typography className="number_Font">
                      {graphData.totalRunningVMCount}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    xl={3}
                    className={
                      vmState === "stopped_vm"
                        ? " Vm stopped_vm "
                        : "align_Text set_Border"
                    }
                    onClick={() => handleVm("stopped_vm")}
                  >
                    <Typography className="text_Font">
                      Total Stopped VM
                    </Typography>
                    <Typography className="number_Font">
                      {graphData.totalStoppedVMCount}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    xl={3}
                    className={
                      vmState === "completed_vm"
                        ? " Vm completed_vm "
                        : "align_Text "
                    }
                    onClick={() => handleVm("completed_vm")}
                  >
                    <Typography className="text_Font">
                      Total Terminated VM
                    </Typography>
                    <Typography className="number_Font">
                      {graphData.completedVMCount}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  {vmState === "completed_vm" ? (
                    <DashboradGraph
                      completedgraphData={completedgraphData}
                      startDate={startDate}
                      endDate={endDate}
                      interval={interval}
                      plotPoints={plotPoints}
                    />
                  ) : vmState === "running_vm" ? (
                    <DashboradGraph
                      runninggraphData={runninggraphData}
                      //month={moment(startDate).format("MMM")}
                      startDate={startDate}
                      endDate={endDate}
                      interval={interval}
                      plotPoints={plotPoints}
                    />
                  ) : vmState === "stopped_vm" ? (
                    <DashboradGraph
                      stoppedgraphData={stoppedgraphData}
                      //month={moment(startDate).format("MMM")}
                      startDate={startDate}
                      endDate={endDate}
                      interval={interval}
                      plotPoints={plotPoints}
                    />
                  ) : (
                    <DashboradGraph
                      vmStatus={vmState}
                      stoppedgraphData={stoppedgraphData}
                      completedgraphData={completedgraphData}
                      runninggraphData={runninggraphData}
                      interval={interval}
                      startDate={startDate}
                      endDate={endDate}
                      plotPoints={plotPoints}
                    />
                  )}
                </Grid>
              </>
            ) : (
              <>
                <Grid container spacing={0} className="graph_Option">
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    xl={2}
                    default
                    className={
                      sessionState === "all_ss" ? " Ss all_ss " : "align_Text "
                    }
                    onClick={() => handleSs("all_ss")}
                  >
                    <Typography className="text_Font">
                      Total Training
                    </Typography>
                    <Typography className="number_Font">
                      {sessionGraphData.totalTrainingCount}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    xl={2}
                    className={
                      sessionState === "total_ss"
                        ? " Ss total_ss "
                        : "align_Text "
                    }
                    onClick={() => handleSs("total_ss")}
                  >
                    <Typography className="text_Font">
                      Total Students
                    </Typography>
                    <Typography className="number_Font">
                      {sessionGraphData.totalStudentsCount}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    xl={2}
                    className={
                      sessionState === "total_ins"
                        ? " Ss total_ins "
                        : "align_Text "
                    }
                    onClick={() => handleSs("total_ins")}
                  >
                    <Typography className="text_Font">
                      Total Instructors
                    </Typography>
                    <Typography className="number_Font">
                      {sessionGraphData.totalInstructorsCount}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    xl={2}
                    className={
                      sessionState === "avg_session_l"
                        ? " Ss avg_session_l "
                        : "align_Text "
                    }
                    onClick={() => handleSs("avg_session_l")}
                  >
                    <Typography className="text_Font">Avg session</Typography>
                    <Typography className="text_Font">length</Typography>
                    <Typography className="number_Font">
                      {sessionGraphData.totalAvgSessionLengthCount} hrs
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    xl={2}
                    className={
                      sessionState === "total_hrs"
                        ? " Ss total_hrs "
                        : "align_Text "
                    }
                    onClick={() => handleSs("total_hrs")}
                  >
                    <Typography className="text_Font">Total Hours</Typography>
                    <Typography className="number_Font">
                      {sessionGraphData.totalHoursCount}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  {sessionState === "total_ss" ? (
                    <DashboradGraph
                      totalStudents={totalStudents}
                      startDate={startDate}
                      endDate={endDate}
                      interval={interval}
                      plotPoints={plotPoints}
                    />
                  ) : sessionState === "total_ins" ? (
                    <DashboradGraph
                      totalInstructors={totalInstructors}
                      startDate={startDate}
                      endDate={endDate}
                      interval={interval}
                      plotPoints={plotPoints}
                    />
                  ) : sessionState === "avg_session_l" ? (
                    <DashboradGraph
                      avgSessionLength={avgSessionLength}
                      startDate={startDate}
                      endDate={endDate}
                      plotPoints={plotPoints}
                      interval={interval}
                    />
                  ) : sessionState === "total_hrs" ? (
                    <DashboradGraph
                      totalHours={totalHours}
                      startDate={startDate}
                      endDate={endDate}
                      plotPoints={plotPoints}
                      interval={interval}
                    />
                  ) : (
                    <DashboradGraph
                      totalTraining={totalTraining}
                      plotPoints={plotPoints}
                      startDate={startDate}
                      endDate={endDate}
                      interval={interval}
                    />
                  )}
                </Grid>
              </>
            )}
          </Grid>
          <DashboardTraining
            training={training}
            check_image_data={imageData.length > 0 ? false : true}
          />
        </Grid>
      </Grid>
      {isLoading ? <MultiLine_Spinner /> : ""}
    </>
  );
};

export default DASHBOARD;
